import React from 'react'

import Relation from "../../../model2/relation/relation"
import RelatedItemIcon from "../common/icon"
import RelatedItemMoreMenu from "../common/more-menu"
import goToItem from "../actions/go-to-item"

type Props = {
    relation    : Relation
    onRemove?   : {(id: ID): void}
    onNavigate? : callback      // runs BEFORE goToItem -- see below
}

// One row of the Related Items POPOVER. A popover is a menu, so it uses the
// menu's own row: `.option` brings the height, inset, hover and truncation, and
// `.with-more` hides the "..." until the row is hovered (skin option.scss /
// with-more.scss). The panel hosts render the glist row instead.
export default function RelatedItemsPopoverRow(props: Props) {

    const {relation} = props

    // onNavigate first, then leave: the popover has to tear itself down on the
    // way out while it is still mounted.
    const onClick = () => {
        props.onNavigate?.()
        goToItem(relation)
    }

    return (
        <div className="option with-more" onClick={onClick}>

            <RelatedItemIcon entity={relation.relatedItem} className="m-r-12"/>

            <div className="label">{relation.title}</div>

            {/* `.with-more` gives it margin-left:auto and the hover toggle -- it
                only has to keep the ui5-ico-more class, which it adds itself. */}
            <RelatedItemMoreMenu relation = {relation}
                                 onRemove = {props.onRemove}/>
        </div>
    )
}
